/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Listen_In_WritingInputs */

const en_homepage_listen_in_writing = /** @type {(inputs: Homepage_Listen_In_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Writing A Paper`)
};

const es_homepage_listen_in_writing = /** @type {(inputs: Homepage_Listen_In_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribiendo un artículo`)
};

/**
* | output |
* | --- |
* | "Writing A Paper" |
*
* @param {Homepage_Listen_In_WritingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_listen_in_writing = /** @type {((inputs?: Homepage_Listen_In_WritingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Listen_In_WritingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_listen_in_writing(inputs)
	return en_homepage_listen_in_writing(inputs)
});